<div class="p-field-inline" [ngClass]="'p-jc-' + numberPosition">
  <ng-container *ngIf="!doTransferCurrencyAmount; else transferAmountEle">
    <sigv-input-number
      #realInput
      *ngIf="!isView; else viewBaseAmountEle"
      [(ngModel)]="amount"
      [placeholder]="'SigvLibrary.PleaseInput' | translate"
      [required]="required"
      (ngModelChange)="onModelChange($event)"
      [inputStyle]="{ 'text-align': numberPosition }"
      [maxFractionDigits]="caseCurrencyFractionDigits.maxFractionDigits"
      [minFractionDigits]="caseCurrencyFractionDigits.minFractionDigits"
      [syncModelValue]="syncModelValue"
      [maxlength]="maxLength"
      (onBlur)="blurEvent.emit($event)"
      (onInput)="inputEvent.emit($event)"
      (onFocus)="focusEvent.emit($event)"
    >
    </sigv-input-number>
    <ng-template #viewBaseAmountEle>
      {{ amount | number : caseCurrencyFormat | replaceNullWith:'-' }}
    </ng-template>
    <div *ngIf="!(isNullOrEmpty(amount) && isView) && showCurrency" class="p-d-flex p-ai-center p-ml-2">
      {{ caseCurrency }}
    </div>
  </ng-container>
  <ng-template #transferAmountEle>
    <sigv-input-number
      #viewInput
      *ngIf="!isView; else viewTransferAmountEle"
      [(ngModel)]="viewModel"
      [placeholder]="'SigvLibrary.PleaseInput' | translate"
      [required]="required"
      (ngModelChange)="onViewModelChange($event)"
      [inputStyle]="{ 'text-align': numberPosition }"
      [maxFractionDigits]="exchangeCurrencyFractionDigits.maxFractionDigits"
      [minFractionDigits]="exchangeCurrencyFractionDigits.minFractionDigits"
      [syncModelValue]="syncModelValue"
      [maxlength]="maxLength"
      (onBlur)="blurEvent.emit($event)"
      (onInput)="inputEvent.emit($event)"
      (onFocus)="focusEvent.emit($event)"
    >
    </sigv-input-number>
    <ng-template #viewTransferAmountEle>
      {{ viewModel | number : exchangeCurrencyFormat | replaceNullWith:'-' }}
    </ng-template>
    <div *ngIf="!(isNullOrEmpty(viewModel) && isView) && showCurrency"
      class="p-d-flex p-ai-center p-ml-2"
      [style]="caseCurrency !== exchangeCurrency ? 'color: #bc9e5c' : ''"
    >
      {{ exchangeCurrency }}
    </div>
  </ng-template>
</div>
